/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {
  ButtonStyled,
  ConfirmationActions,
  ConfirmationButton,
  ConfirmationContent,
  ConfirmationIcon,
  ConfirmationText,
  ConfirmationTitle,
} from './styles';

const CustomDialog = ({
  isOpen,
  title,
  text,
  okFunction,
  notOkFunction,
  openCloseFx,
  actionsDisabled = false,
  acceptButtonLabel = 'Aceptar',
  cancelButtonLabel = 'Cancelar',
  showCancelButton = true,
  variant = 'default',
  icon = /** @type {React.ReactNode} */ (null),
}) => {
  const handleCancel = () => {
    notOkFunction();
    openCloseFx(false);
  };

  const handleAccept = () => {
    okFunction();
    openCloseFx(false);
  };

  if (variant === 'confirmation') {
    return (
      <Dialog
        open={isOpen}
        onClose={actionsDisabled ? undefined : handleCancel}
        disableEscapeKeyDown={actionsDisabled}
        fullWidth
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
        PaperProps={{ style: { borderRadius: 12, maxWidth: 440 } }}
      >
        <DialogContent>
          <ConfirmationContent>
            {icon ? <ConfirmationIcon>{icon}</ConfirmationIcon> : null}
            <ConfirmationTitle id="confirmation-dialog-title">{title}</ConfirmationTitle>
            <ConfirmationText id="confirmation-dialog-description">{text}</ConfirmationText>
          </ConfirmationContent>
        </DialogContent>
        <DialogActions>
          <ConfirmationActions>
            {showCancelButton && (
              <ConfirmationButton disabled={actionsDisabled} onClick={handleCancel}>
                {cancelButtonLabel}
              </ConfirmationButton>
            )}
            <ConfirmationButton
              $confirm
              disabled={actionsDisabled}
              onClick={handleAccept}
            >
              {acceptButtonLabel || 'Aceptar'}
            </ConfirmationButton>
          </ConfirmationActions>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="dialog"
    >
      <DialogTitle id="dialog">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {showCancelButton && (
        <ButtonStyled
          error
          autoFocus
          disabled={actionsDisabled}
          onClick={handleCancel}
        >
          {cancelButtonLabel}
        </ButtonStyled>
        )}
        <ButtonStyled
          autoFocus
          disabled={actionsDisabled}
          onClick={handleAccept}
        >
          {acceptButtonLabel || 'Aceptar'}
        </ButtonStyled>
      </DialogActions>
    </Dialog>
  );
};

CustomDialog.propTypes = {
  acceptButtonLabel: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  openCloseFx: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  okFunction: PropTypes.func.isRequired,
  notOkFunction: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'confirmation']),
  icon: PropTypes.node,
};

export default CustomDialog;
